/* ==========================================================================
   custom-tlpc.js — shared behaviour for WAGR custom sections
   Currently: reveal-on-scroll for .reveal-tlpc elements (every TLPC heading).
   ========================================================================== */
(function () {
  'use strict';

  /* Tells the failsafe in theme.liquid that this file arrived, so the
     pre-animation state is safe to keep. */
  window.__tlpcRevealLoaded = true;

  var root = document.documentElement;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduceMotion || !('IntersectionObserver' in window)) {
    root.classList.remove('tlpc-reveal-ready');
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) continue;
        entries[i].target.classList.add('is-revealed');
        observer.unobserve(entries[i].target);
      }
    },
    {
      root: null,
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.12
    }
  );

  function observe(scope) {
    var targets = (scope || document).querySelectorAll('.reveal-tlpc:not(.is-revealed)');
    for (var i = 0; i < targets.length; i++) {
      observer.observe(targets[i]);
    }
  }

  function init() {
    observe(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme editor re-renders a section without a full page load */
  document.addEventListener('shopify:section:load', function (event) {
    observe(event.target);
  });

  /* Anything still hidden after the page settles gets shown, so a missed
     observation can never leave content invisible. */
  window.addEventListener('load', function () {
    window.setTimeout(function () {
      var stuck = document.querySelectorAll('.reveal-tlpc:not(.is-revealed)');
      for (var i = 0; i < stuck.length; i++) {
        var box = stuck[i].getBoundingClientRect();
        if (box.top < window.innerHeight && box.bottom > 0) {
          stuck[i].classList.add('is-revealed');
        }
      }
    }, 400);
  });
})();